import { render } from "./App.vue?vue&type=template&id=63b19ced"
const script = {}

import "./App.vue?vue&type=style&index=0&id=63b19ced&lang=css"

import exportComponent from "D:\\Jonathan\\nona\\launchxhackathon\\hackatonlaunchx\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__